
        import * as module0 from './../../components/pulse/modal_controller.js';import * as module1 from './../../components/pulse/toast_controller.js'
        const modules = [{name: '..--..--components--pulse--modal', module: module0, filename: '../../components/pulse/modal_controller.js'},{name: '..--..--components--pulse--toast', module: module1, filename: '../../components/pulse/toast_controller.js'}]
        export default modules;
      